// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__yeKF1","loaderOuter":"PageOverlayLoader_loaderOuter__Q2M91"};